'use client';

import { useEffect, useRef } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { isDev, isPreview, parseSampleRate } from '@ui/lib/utils';

export default function DatadogInit() {
  const initedRef = useRef(false);

  useEffect(() => {
    if (isDev || initedRef.current) return;

    if (typeof window !== 'undefined' && (window as any).__DATADOG_INIT_DONE) return;

    initedRef.current = true;
    if (typeof window !== 'undefined') {
      (window as any).__DATADOG_INIT_DONE = true;
    }

    const version = process.env.NEXT_PUBLIC_APP_VERSION;

    datadogRum.init({
      applicationId: 'ddbf0503-8482-470e-82f1-41928aa80b98',
      clientToken: 'pubaaf6584d53b517409b63a8d6cb120145',
      site: 'datadoghq.eu',
      service: 'hirebetter-platform',
      env: isPreview ? 'preview' : 'prod',

      version,
      sessionSampleRate: parseSampleRate(process.env.NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE, 50),
      // Replay starts after login only (see contexts/user-context.tsx), never for anonymous visitors.
      sessionReplaySampleRate: 0,
      startSessionReplayRecordingManually: true,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow',
    });

    datadogLogs.init({
      clientToken: 'pubaaf6584d53b517409b63a8d6cb120145',
      site: 'datadoghq.eu',
      service: 'hirebetter-platform',
      env: isPreview ? 'preview' : 'prod',
      version,
      sessionSampleRate: parseSampleRate(process.env.NEXT_PUBLIC_DD_LOGS_SAMPLE_RATE, 100),
      forwardConsoleLogs: 'all',
    });
  }, []);

  return null;
}
